// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___YoHW9_common"};